import React, { useState, useEffect, useRef, useMemo } from "react";
import { FixedSizeList as List } from "react-window";

import library from "../../../assets/json/library.json";
import {
  PiArrowBendDoubleUpLeftFill,
  PiArrowBendDoubleUpRightFill,
} from "react-icons/pi";

import {
  getDocument,
  getQuizQuestionsfromList,
  updateDocument,
} from "../../../firebase-functions/database";
import { auth } from "../../../firebase-functions/config";

import { QuestPerk } from "./QuestPerk";

const PERK_WIDTH = 200; // Distance between rewards in pixels
const BUFFER_ITEMS = 3; // Extra items to render off-screen for smooth scrolling

const decodedText = (text) => {
  if (text) {
    return text.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
  } else {
    return "";
  }
};

const rewardsTable = [
  { title: "50 gold", type: "gold", value: 50, xp: 200 },
  { title: "1 Robux", type: "robux", value: 1, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  { title: "2 Robux", type: "robux", value: 2, xp: 200 },
  { title: "Book of History", type: "magicBook", value: 1, xp: 200 },
  { title: "200 gold", type: "gold", value: 200, xp: 200 },
  // { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  { title: "Book of Time Travel", type: "magicBook", value: 1, xp: 200 },
  { title: "3 Robux", type: "robux", value: 3, xp: 200 },
  { title: "50 gold", type: "gold", value: 50, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  // { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "2 Robux", type: "robux", value: 2, xp: 200 },
  { title: "150 gold", type: "gold", value: 150, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  // { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "150 gold", type: "gold", value: 150, xp: 200 },
  { title: "Word Potion", type: "potion", value: 1, xp: 200 },
  { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "4 Robux", type: "robux", value: 4, xp: 200 },
  { title: "5 Robux", type: "robux", value: 5, xp: 200 },
  { title: "200 gold", type: "gold", value: 200, xp: 200 },
  { title: "1 Rare Stamp", type: "rareStamp", value: 1, xp: 200 },
  { title: "1 Robux", type: "robux", value: 1, xp: 200 },
  { title: "250 gold", type: "gold", value: 250, xp: 200 },
  // {
  //   title: "1 Silver Scratch Card",
  //   type: "scratchCard",
  //   subtype: "silver",
  //   value: 1,
  //   xp: 200,
  // },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  { title: "Book of Time Travel", type: "magicBook", value: 1, xp: 200 },
  { title: "150 gold", type: "gold", value: 150, xp: 200 },
  { title: "2 Robux", type: "robux", value: 2, xp: 200 },
  { title: "500 gold", type: "gold", value: 500, xp: 200 },
  { title: "5 Robux", type: "robux", value: 5, xp: 200 },

  { title: "250 gold", type: "gold", value: 250, xp: 200 },
  // { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "100 gold", type: "gold", value: 100, xp: 200 },
  { title: "3 Robux", type: "robux", value: 3, xp: 200 },
  { title: "Book of History", type: "magicBook", value: 1, xp: 200 },
  { title: "300 gold", type: "gold", value: 300, xp: 200 },
  { title: "350 gold", type: "gold", value: 350, xp: 200 },
  // { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },

  { title: "2 Robux", type: "robux", value: 2, xp: 200 },
  { title: "250 gold", type: "gold", value: 250, xp: 200 },
  { title: "1 Stamp", type: "stamp", value: 1, xp: 200 },
  { title: "6 Robux", type: "robux", value: 6, xp: 200 },

  { title: "Book of Quest", type: "magicBook", value: 1, xp: 200 },
  { title: "300 gold", type: "gold", value: 300, xp: 200 },
  { title: "350 gold", type: "gold", value: 350, xp: 200 },
  // { title: "2 Stamps", type: "stamp", value: 2, xp: 200 },
  { title: "4 Robux", type: "robux", value: 4, xp: 200 },
  { title: "350 gold", type: "gold", value: 350, xp: 200 },
  { title: "Word Potion", type: "potion", value: 1, xp: 200 },
  { title: "Book of Time Travel", type: "magicBook", value: 1, xp: 200 },
  { title: "400 gold", type: "gold", value: 400, xp: 200 },
  { title: "8 Robux", type: "robux", value: 8, xp: 200 },
  // {
  //   title: "1 Gold Scratch Card",
  //   type: "scratchCard",
  //   subtype: "gold",
  //   value: 1,
  //   xp: 200,
  // },
  { title: "20 Robux", type: "robux", value: 20, xp: 200 },
];

const QuestBook = ({
  bk,
  bookIndex,
  setBookIndex,
  bookList,
  totalReadingTime,
  setTotalReadingTime,
  state,
  setState,
  setOuterPageIndex,

  calculateReadingDuration,
}) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [bookPages, setBookPages] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [readingTime, setReadingTime] = useState({});
  const [wpm, setWpm] = useState(0);

  const [previousPageNumber, setPreviousPageNumber] = useState();

  const fetchPages = async (id, pagesCap) => {
    if (!id) return;

    const createFetchPromise = (page) => {
      const url = `https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbooks%2F${id}%2Fpage-${page}.jpg?alt=media`;
      return fetch(url)
        .then((res) => {
          if (res.ok) {
            return url;
          } else {
            // Instead of throwing here, resolve with null to keep Promise.allSettled clean
            return null;
          }
        })
        .catch(() => null); // Catch network errors and return null as well
    };

    const createFinalFetchPromise = () => {
      const url =
        "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2F0-final-page.jpg?alt=media&token=e6ada71e-b226-4a75-9da5-c1d6486a2b40";
      return fetch(url)
        .then((res) => {
          if (res.ok) {
            return url;
          } else {
            // Instead of throwing here, resolve with null to keep Promise.allSettled clean
            return null;
          }
        })
        .catch(() => null); // Catch network errors and return null as well
    };

    const firstBatch = [];

    for (let page = 0; page <= pagesCap + 1; page++) {
      if (page === 2) continue;
      firstBatch.push(createFetchPromise(page)); // priority pages
    }
    firstBatch.push(createFinalFetchPromise());

    try {
      const firstResults = await Promise.all(firstBatch);
      const validFirstPages = firstResults.filter(Boolean); // remove nulls

      setBookPages(validFirstPages);
      setTotalPages(validFirstPages.length);
    } catch (err) {}
  };

  const handlePageFlip = (pageNumber) => {
    const tempTimeCounter = { ...readingTime };
    let newObjectArray;

    if (!tempTimeCounter[pageNumber]) {
      newObjectArray = [
        {
          start: new Date(),
        },
      ];
    } else {
      newObjectArray = tempTimeCounter[pageNumber];
      newObjectArray.push({
        start: new Date(),
      });
    }
    tempTimeCounter[pageNumber] = newObjectArray;

    if (previousPageNumber && tempTimeCounter[previousPageNumber]) {
      const l = tempTimeCounter[previousPageNumber].length;
      tempTimeCounter[previousPageNumber][l - 1].end = new Date();
    }
    setPreviousPageNumber(pageNumber);
    setReadingTime(tempTimeCounter);
  };

  useEffect(() => {
    if (!library) {
      return;
    }

    if (bookPages.length === 0) {
      fetchPages(bk.id, library.find((a) => a.id === bk.id).pages - 1);
    }
  }, [library]);

  useEffect(() => {
    if (Object.keys(readingTime).length === totalPages && totalPages > 0) {
      setWpm(calculateReadingDuration(readingTime, bk));
    }
  }, [readingTime]);

  useEffect(() => {
    handlePageFlip(pageIndex);
    setOuterPageIndex(pageIndex);
  }, [pageIndex]);

  useEffect(() => {
    let tempTempTotalReadingTime = [...totalReadingTime];
    tempTempTotalReadingTime[bookIndex] = readingTime;
    setTotalReadingTime(tempTempTotalReadingTime);
  }, [readingTime]);

  useEffect(() => {
    setOuterPageIndex(0);
    setPageIndex(0);
  }, [bookIndex]);

  return (
    <div className="quest-book-container">
      <div className="quest-book-page-div">
        {pageIndex === bk.pages - 2 && state === "read" && (
          <div className="btn-next-book-container">
            {bookIndex < bookList.length - 1 ? (
              <button
                className={wpm > 600 ? "btn-next-book-container-disabled" : ""}
                onClick={() => {
                  if (wpm > 600) return;
                  setBookIndex(bookIndex + 1);
                  setPageIndex(0);
                }}
              >
                Next Book
              </button>
            ) : (
              <button
                onClick={() => {
                  setState("quiz");
                }}
              >
                Done Reading
              </button>
            )}
          </div>
        )}
        <div className="quest-book-nav-buttons">
          <div
            className="quest-nav-btn quest-nav-btn-previous"
            onClick={() => setPageIndex((prev) => Math.max(prev - 1, 0))}
          >
            <PiArrowBendDoubleUpLeftFill />
          </div>

          <div
            className="quest-nav-btn quest-nav-btn-next"
            onClick={() =>
              setPageIndex((prev) => Math.min(prev + 1, bookPages.length - 1))
            }
          >
            <PiArrowBendDoubleUpRightFill />
          </div>
        </div>

        <img
          className="quest-book-page"
          key={bk.index + "-" + pageIndex}
          src={bookPages[pageIndex]}
          alt={bk.title}
        />
      </div>
    </div>
  );
};

const QuestQuiz = ({
  bookList,
  bookIndex,
  setBookIndex,
  setOuterQuestionIndex,
  readerProfile,
  streaks,
  setStreaks,
  maxStreaks,
  setMaxStreaks,
  questions,
  setQuestions,
  totalReadingTime,
  calculateReadingDuration,
  setXp,
  setAnnouncementQueue,
  setState,
}) => {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [questionState, setQuestionState] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [questionLogs, setQuestionLogs] = useState({});
  const [timer, setTimer] = useState(new Date());

  const audioCorrect = new Audio(
    "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fquests%2Fcorrect.mp3?alt=media&token=90810dfc-7299-4834-b6ef-ea3ac7daae6c"
  );
  const audioIncorrect = new Audio(
    "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fquests%2Fincorrect.mp3?alt=media&token=9760a8dc-73fc-4dfe-8e43-83d91a2716b0"
  );

  const handleUpdateQuestionOnEvaluate = (tempStreaks, qLogs) => {
    getDocument("demoReaders", readerProfile.id).then((res) => {
      const todaysDate = new Date();
      const DDMMYYYY =
        todaysDate.getDate() +
        "-" +
        todaysDate.getMonth() +
        1 +
        "-" +
        todaysDate.getFullYear();

      let latestReaderProfile = res.data;
      let newQuestData = latestReaderProfile.readerQuests;
      let todaysData = newQuestData.entries[DDMMYYYY];

      newQuestData.data.streaks = tempStreaks;
      newQuestData.data.maxStreaks =
        tempStreaks > maxStreaks ? tempStreaks : maxStreaks;
      todaysData.questionIndex =
        tempStreaks === 0 ? questionIndex : questionIndex + 1;
      todaysData.questionLogs = qLogs;

      //xp
      if (tempStreaks !== 0) {
        let tempXp = newQuestData.data.xp || 0;
        // correct answer
        tempXp = tempXp + 40;
        // timer bonus
        const time = Math.floor((new Date() - timer) / 1000);
        if (time == 0) {
          tempXp = tempXp + 50;
        } else if (time <= 1) {
          tempXp = tempXp + 35;
        } else if (time <= 5) {
          tempXp = tempXp + 15;
        } else if (time <= 10) {
          tempXp = tempXp + 10;
        } else if (time <= 20) {
          tempXp = tempXp + 5;
        } else if (time <= 60) {
          tempXp = tempXp + 1;
        }
        tempXp = tempXp + Math.floor(tempStreaks * 1.2);
        setXp(tempXp);
        newQuestData.data.xp = tempXp;

        // reward
        const lastClaimedXpPoint = newQuestData.data.lastClaimedXpPoint || 0;
        let unclaimedRewards = [];
        for (let j = lastClaimedXpPoint; j + 200 < tempXp; j += 200) {
          unclaimedRewards.push(j / 200);
        }
        if (unclaimedRewards.length > 0) {
          setAnnouncementQueue(unclaimedRewards.map((j) => rewardsTable[j]));
          unclaimedRewards.map((j) => {
            const reward = rewardsTable[j];
            newQuestData.data.lastClaimedXpPoint = j * 200 + 200;
            if (reward.type === "gold") {
              latestReaderProfile.starDeduction =
                latestReaderProfile.starDeduction - reward.value;
            } else if (reward.type === "robux") {
              latestReaderProfile.robux =
                latestReaderProfile.robux - reward.value;
            }
            if (reward.type === "potion") {
              latestReaderProfile.inventory.wordPotion =
                latestReaderProfile.inventory.wordPotion + 1;
            }
            if (reward.type === "magicBook") {
              if (reward.title === "Book of History") {
                latestReaderProfile.inventory.bookOfHistory =
                  latestReaderProfile.inventory.bookOfHistory + 1;
              } else if (reward.title === "Book of Time Travel") {
                latestReaderProfile.inventory.bookOfTimeTravel =
                  latestReaderProfile.inventory.bookOfTimeTravel + 1;
              } else if (reward.title === "Book of Quest") {
                const tempNumber =
                  latestReaderProfile.inventory.bookOfQuest || 0;
                latestReaderProfile.inventory.bookOfQuest = tempNumber + 1;
              }
            }
          });
        }
      }

      // last question clean up
      if (todaysData.questionIndex === todaysData.questions.length) {
        let latestPerformance = latestReaderProfile.performance;
        todaysData.state = "done";
        setState("done");
        todaysData.selectedBooks.map((selectedBk, bkIndex) => {
          let qLogsForThisBook = [];
          todaysData.questions.map((q, qIndex) => {
            if (parseInt(q.bookId) === selectedBk.id) {
              qLogsForThisBook.push(qLogs[qIndex]);
            }
          });
          const percentile =
            qLogsForThisBook.flat().length === 0
              ? 1
              : qLogsForThisBook.flat().filter((a) => a === true).length /
                qLogsForThisBook.flat().length;
          const questionLength = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
          ].includes(selectedBk.level)
            ? 5
            : 10;
          latestReaderProfile.read = latestReaderProfile.read + 1;
          let newPerformanceObject = {
            book: {
              bookId: selectedBk.id,
              title: selectedBk.title,
              pages: selectedBk.pages,
              wordLength: selectedBk.wordLength,
            },
            stats: {
              wpm: todaysData.totalReadingTime[bkIndex],
              score: percentile * questionLength,
              percentile: percentile,
              duration:
                todaysData.totalReadingTime[bkIndex] * selectedBk.wordLength,
            },
            dateRead: new Date(),
            type: "quest",
          };

          latestPerformance.push(newPerformanceObject);
        });
      }

      updateDocument(
        "demoReaders",
        latestReaderProfile.id,
        latestReaderProfile,
        auth.currentUser
      );
    });
  };

  const chooseQuestionsFromBooks = (recentReaderProfile) => {
    if (!bookList || bookList.length === 0) return;

    getQuizQuestionsfromList(bookList.map((bk) => bk.id)).then((res) => {
      const result = res.message;

      let quizPool = [];

      Object.values(result).map((bundle, i) => {
        bundle.questions
          .filter((question) => question?.choices?.length > 0)
          .map((question) => {
            quizPool.push({
              // console.log({
              bookId: Object.keys(result)[i],
              choices: question.choices,
              question: question.question,
            });
          });
      });

      let random10NumbersFromthePool = [];

      while (random10NumbersFromthePool.length < 10) {
        let randomIndex = Math.floor(Math.random() * quizPool.length);
        if (!random10NumbersFromthePool.includes(randomIndex)) {
          random10NumbersFromthePool.push(randomIndex);
        }
      }
      const selectedRandomQuestions = random10NumbersFromthePool
        .map((i) => quizPool[i])
        .sort((a, b) => a.bookId - b.bookId);

      let newReaderData = { ...recentReaderProfile };

      const todaysDate = new Date();
      const DDMMYYYY =
        todaysDate.getDate() +
        "-" +
        todaysDate.getMonth() +
        1 +
        "-" +
        todaysDate.getFullYear();

      newReaderData.readerQuests.entries[DDMMYYYY].questions =
        selectedRandomQuestions;

      let wpmArray = [];

      totalReadingTime.map((lg, i) => {
        wpmArray.push(calculateReadingDuration(lg, bookList[i]));
      });

      newReaderData.readerQuests.entries[DDMMYYYY].state = "quiz";

      newReaderData.readerQuests.entries[DDMMYYYY].questionIndex = 0;

      newReaderData.readerQuests.entries[DDMMYYYY].totalReadingTime = wpmArray;
      newReaderData.readerQuests.entries[DDMMYYYY].state = "quiz";

      updateDocument(
        "demoReaders",
        readerProfile.id,
        newReaderData,
        auth.currentUser
      ).then((res) => {
        if (!res.success) {
          console.error(res.message);
          return;
        }
        setQuestions(selectedRandomQuestions);
      });
    });
  };

  const evaluateChoice = (choice) => {
    if (choice.isTrue) {
      setQuestionState("correct");
      audioCorrect.play();
      setStreaks(streaks + 1);
      if (streaks + 1 > maxStreaks) {
        setMaxStreaks(streaks + 1);
      }

      let tempLogs = { ...questionLogs };
      if (tempLogs[questionIndex]) {
        let tempArray = [...tempLogs[questionIndex]];
        tempArray.push(true);
        tempLogs[questionIndex] = tempArray;
      } else {
        tempLogs[questionIndex] = [true];
      }
      setQuestionLogs(tempLogs);

      handleUpdateQuestionOnEvaluate(streaks + 1, tempLogs);
      setTimeout(() => {
        setQuestionIndex(questionIndex + 1);
        setTimer(new Date());
        setQuestionState(null);
      }, 3000);
    } else {
      setQuestionState("incorrect");
      audioIncorrect.play();
      let tempLogs = { ...questionLogs };
      if (tempLogs[questionIndex]) {
        let tempArray = [...tempLogs[questionIndex]];
        tempArray.push(false);
        tempLogs[questionIndex] = tempArray;
      } else {
        tempLogs[questionIndex] = [false];
      }
      setQuestionLogs(tempLogs);

      setStreaks(0);
      handleUpdateQuestionOnEvaluate(0, tempLogs);
    }

    setTimeout(() => {
      setQuestionState(null);
    }, 3000);
  };

  useEffect(() => {
    if (questions.length !== 0) return;
    getDocument("demoReaders", readerProfile.id).then((res) => {
      const todaysDate = new Date();
      const DDMMYYYY =
        todaysDate.getDate() +
        "-" +
        todaysDate.getMonth() +
        1 +
        "-" +
        todaysDate.getFullYear();

      const newQuestions = res.data.readerQuests.entries[DDMMYYYY].questions;
      if (newQuestions) {
        setQuestions(newQuestions);
        setQuestionIndex(res.data.readerQuests.entries[DDMMYYYY].questionIndex);
        setQuestionLogs(res.data.readerQuests.entries[DDMMYYYY].questionLogs);
      } else {
        chooseQuestionsFromBooks(res.data);
      }
    });
  }, [bookList]);

  useEffect(() => {
    if (questions.length === 0) {
      return;
    }
    const newIndex = bookList
      .map((bk) => bk.id)
      .indexOf(parseInt(questions[questionIndex]?.bookId));

    if (bookIndex !== newIndex) {
      setBookIndex(newIndex);
    }
    setOuterQuestionIndex(questionIndex);
  }, [questionIndex, questions]);

  return (
    <div className="quest-quiz-container" key={"quiz-" + questionIndex}>
      <div
        className="quest-question"
        dangerouslySetInnerHTML={{
          __html: decodedText(questions[questionIndex]?.question),
        }}
      ></div>
      <div className="quest-choices">
        {questions[questionIndex]?.choices.map((choice, ind) => {
          return (
            <div
              className={
                selectedOption === ind
                  ? questionState === "correct"
                    ? "div-quest-choice div-quest-choice-correct"
                    : questionState === "incorrect"
                    ? "div-quest-choice div-quest-choice-incorrect"
                    : "div-quest-choice"
                  : "div-quest-choice"
              }
              key={"choice-" + questionIndex + "-" + ind}
              // --- ADD THIS LINE BELOW ---
              style={{ animationDelay: `${0.5 + ind * 0.2}s` }}
              // ---------------------------

              dangerouslySetInnerHTML={{
                __html: decodedText(choice.answer),
              }}
              onClick={() => {
                if (questionState === null) {
                  evaluateChoice(choice);
                  setSelectedOption(ind);
                }
              }}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

const QuestProgress = ({
  state,
  selectedBooks,
  bookIndex,
  pageIndex,
  questionIndex,
}) => {
  const [percentage, setPercentage] = useState(0);
  const [visualPercentage, setVisualPercentage] = useState(0);
  const milestones = {
    init: 10,
    read: 70,
    quiz: 20,
  };
  useEffect(() => {
    let tempPercentage = 10;

    if (state === "read") {
      if (
        bookIndex === null ||
        selectedBooks.length === 0 ||
        pageIndex === null
      )
        return;
      const wordLengthArray = selectedBooks.map((b) => b.wordLength);
      const totalWordLength = wordLengthArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const currentBook = selectedBooks[bookIndex];

      let value = 0;
      for (let i = 0; i < bookIndex; i++) {
        value = value + wordLengthArray[i];
      }

      let valuePerPage = currentBook.wordLength / currentBook.pages;
      value = value + valuePerPage * (pageIndex + 1);
      const toBeAdded = (value * 100) / totalWordLength;

      tempPercentage = tempPercentage + (toBeAdded * milestones.read) / 100;

      setPercentage(tempPercentage);
    } else if (state === "quiz") {
      let tempPercentage = 80;
      if (questionIndex === null) return;

      tempPercentage += 2 * questionIndex;
      setPercentage(tempPercentage);
    }
  }, [state, selectedBooks, bookIndex, pageIndex, questionIndex]);

  useEffect(() => {
    let rafId = null;
    const duration = 500; // ms
    const startTime = performance.now();
    const from = visualPercentage;
    const to = percentage;

    // easeInOutQuad
    const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = ease(progress);
      const value = from + (to - from) * eased;
      setVisualPercentage(value);

      if (progress < 1) {
        rafId = requestAnimationFrame(step);
      }
    };

    rafId = requestAnimationFrame(step);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [percentage]);

  return (
    <div className="quest-progress-container">
      <div className="quest-bar-div">
        <div className="quest-progress-bar-outer">
          <div
            className="quest-progress-bar-inner"
            style={{
              width: visualPercentage + "%",
            }}
          ></div>
        </div>
        <div
          className="quest-milestone-bubble"
          style={{
            left: 0 + "%",
          }}
        ></div>
        <div
          className="quest-milestone-bubble"
          style={{
            left: milestones.init + "%",
          }}
        ></div>
        <div
          className={
            milestones.read + milestones.init <= percentage
              ? "quest-milestone-bubble "
              : "quest-milestone-bubble quest-milestone-bubble-blank"
          }
          style={{
            left: milestones.read + milestones.init + "%",
          }}
        ></div>
        <div
          className={
            milestones.read + milestones.init + milestones.quiz <= percentage
              ? "quest-milestone-bubble "
              : "quest-milestone-bubble quest-milestone-bubble-blank"
          }
          style={{
            left: milestones.read + milestones.init + milestones.quiz + "%",
          }}
        ></div>

        {selectedBooks &&
          selectedBooks.map((bk, i) => {
            const arr = selectedBooks.map((b) => b.wordLength);
            const total = arr.reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
            let accumulatedPos = 0;
            arr.map((a, j) => {
              if (j < i) {
                accumulatedPos = a + accumulatedPos;
              }
            });

            const position = (accumulatedPos * 100) / total;

            return (
              <img
                className="quest-book-thumbnail"
                key={"book-thumbnail-" + i}
                src={`https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbooks%2F${bk.id}%2Fpage-0.jpg?alt=media`}
                style={{
                  left: position * 0.7 + milestones.init + "%",
                }}
              />
            );
          })}
      </div>
    </div>
  );
};

const Streaks = ({ streaks, maxStreaks }) => {
  return (
    <div className="streaks-container">
      <h2>Streaks: {streaks}</h2>
      <p>Max: {maxStreaks}</p>
    </div>
  );
};

export const Rewards = ({ xp }) => {
  // --- Animation States ---
  const [visualXp, setVisualXp] = useState(0);
  const [cap, setCap] = useState(100);
  const capStep = 10000;

  // --- Virtualization States ---
  const [scrollLeft, setScrollLeft] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);

  const scrollRef = useRef(null);

  // 1. Calculate the total width of the scrolling area
  // It must be at least as wide as the XP bar OR the last reward
  const totalWidth = useMemo(() => {
    const rewardsWidth = (rewardsTable.length || 0) * PERK_WIDTH;
    // Ensure the container is at least as wide as the visual XP or the calculated Cap
    return Math.max(rewardsWidth, cap, visualXp) + 300; // +300 for padding at the end
  }, [rewardsTable, cap, visualXp]);

  // 2. XP Animation Logic (Preserved from your code)
  useEffect(() => {
    setCap(Math.ceil(xp / capStep) * capStep);
    let rafId = null;
    const duration = 500;
    const startTime = performance.now();
    const from = visualXp;
    const to = xp;
    const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = ease(progress);
      setVisualXp(from + (to - from) * eased);
      if (progress < 1) rafId = requestAnimationFrame(step);
    };
    rafId = requestAnimationFrame(step);
    return () => rafId && cancelAnimationFrame(rafId);
  }, [xp]);

  // 3. Auto-Scroll Logic (Preserved & Optimized)
  useEffect(() => {
    if (!scrollRef.current) return;
    const target = Math.max(xp - 300, 0); // Center the progress a bit
    const start = scrollRef.current.scrollLeft;
    const duration = 500;
    const startTime = performance.now();
    const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    let rafId = requestAnimationFrame(function step(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = ease(progress);
      const newScroll = start + (target - start) * eased;

      scrollRef.current.scrollLeft = newScroll;
      // Important: Manually update state here because programmatic scroll
      // might not fire onScroll fast enough for virtualization
      setScrollLeft(newScroll);

      if (progress < 1) rafId = requestAnimationFrame(step);
    });

    return () => cancelAnimationFrame(rafId);
  }, [xp, cap]);

  // 4. Handle Container Resize (for virtualization calc)
  useEffect(() => {
    if (scrollRef.current) {
      setContainerWidth(scrollRef.current.clientWidth);
    }
    const handleResize = () => {
      if (scrollRef.current) setContainerWidth(scrollRef.current.clientWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 5. Calculate Visible Range
  const { visibleStartIndex, visibleEndIndex } = useMemo(() => {
    const start = Math.floor(scrollLeft / PERK_WIDTH);
    const end = Math.ceil((scrollLeft + containerWidth) / PERK_WIDTH);

    return {
      visibleStartIndex: Math.max(0, start - BUFFER_ITEMS),
      visibleEndIndex: Math.min(rewardsTable.length, end + BUFFER_ITEMS),
    };
  }, [scrollLeft, containerWidth, rewardsTable.length]);

  return (
    <div className="quest-rewards-container">
      <div
        className="quest-rewards-outer"
        ref={scrollRef}
        onScroll={(e) => setScrollLeft(e.currentTarget.scrollLeft)}
      >
        {/* Ghost container defines the full scrollable width */}
        <div
          style={{ position: "relative", width: totalWidth, height: "100%" }}
        >
          {/* The Progress Bar */}
          <div
            className="quest-rewards-inner"
            style={{ width: visualXp }}
          ></div>

          {/* Render ONLY visible rewards */}
          {rewardsTable
            .slice(visibleStartIndex, visibleEndIndex)
            .map((reward, i) => {
              // We must use the original index to position it correctly absolute
              const originalIndex = visibleStartIndex + i;
              return (
                <QuestPerk
                  key={originalIndex}
                  index={originalIndex}
                  claimed={xp >= originalIndex * PERK_WIDTH + PERK_WIDTH} // Example claim logic
                  message={reward.title || "reward"}
                  type={reward.type || "gold"}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
const QuestRewardCelebration = ({
  setAnnouncementQueue,
  activeAnnouncement,
  announcementQueue,
  setActiveAnnouncement,
}) => {
  const imageURLs = {
    gold: "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_2.png?alt=media&token=b18097b0-407b-4668-88e1-fb7e4e2f3696",
    robux:
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FRobux_2019_Logo_gold.svg.png?alt=media&token=def71a22-9b87-409f-ad4c-f68a4fca9864",
    potion:
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Power_potion.png?alt=media&token=af882f44-96a2-4a63-8b26-b8d4a3239893",
    "Book of History":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Heroes.png?alt=media&token=fd103eaa-458c-4273-82eb-ff1fb3e0e624",
    "Book of Time Travel":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Everything.png?alt=media&token=a29e8976-ddcf-42bb-a4f0-9cf36114341e",
    "Book of Quest":
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Troops.png?alt=media&token=bacec6ad-1da8-4386-9ffa-8adf91ae600b",
  };
  const audioLevelUp = new Audio(
    "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsound-effects%2Fquests%2Flevel-up.mp3?alt=media&token=ee32bd8c-afe9-46a9-8cb6-9207fd5c0713"
  );

  const imgSrc =
    activeAnnouncement.type === "robux"
      ? imageURLs.robux
      : activeAnnouncement.type === "potion"
      ? imageURLs.potion
      : activeAnnouncement.type === "magicBook"
      ? imageURLs[activeAnnouncement.title]
      : imageURLs.gold;

  useEffect(() => {
    if (!activeAnnouncement) return;

    // play sound
    audioLevelUp.play();

    const timer = setTimeout(() => {
      setAnnouncementQueue((prevQueue) => prevQueue.slice(1));
      setActiveAnnouncement(null);
    }, 2000);

    return () => clearTimeout(timer);
  }, [activeAnnouncement, setAnnouncementQueue]);

  return (
    <>
      <div className="reward-announcement-container-outer"></div>
      <div className="reward-announcement-container">
        <div className="reward-announcement-inner-box">
          <img src={imgSrc} alt="" className="reward-announcement-image" />

          <h2>{activeAnnouncement.title}</h2>
        </div>
      </div>
    </>
  );
};

export const QuestReadingRoom = ({
  readerProfile,
  bookList,
  setBookList,
  state,
  setState,
  streaks,
  setStreaks,
  maxStreaks,
  setMaxStreaks,
}) => {
  const [activeBook, setActiveBook] = useState();
  const [bookIndex, setBookIndex] = useState(0);
  const [totalReadingTime, setTotalReadingTime] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [xp, setXp] = useState(null);
  const [announcementQueue, setAnnouncementQueue] = useState([]);
  const [activeAnnouncement, setActiveAnnouncement] = useState(null);

  useEffect(() => {
    if (!readerProfile) return;
    const todaysDate = new Date();
    const DDMMYYYY =
      todaysDate.getDate() +
      "-" +
      todaysDate.getMonth() +
      1 +
      "-" +
      todaysDate.getFullYear();

    setBookList(readerProfile.readerQuests.entries[DDMMYYYY].selectedBooks);
    setXp(readerProfile.readerQuests.data.xp || 0);
  }, []);

  useEffect(() => {
    if (bookList.length > 0 && bookIndex !== null) {
      setActiveBook(bookList[bookIndex]);
    }
  }, [bookList, bookIndex]);

  const calculateReadingDuration = (tempLogs, bk) => {
    let total = 0;

    Object.values(tempLogs).map((pg) => {
      let pageTotal = 0;
      pg.map((flip) => {
        if (flip.end) {
          pageTotal = pageTotal + parseInt(flip.end - flip.start);
        }
      });
      total = total + pageTotal;
    });

    return Math.round((bk.wordLength * 60000) / total);
  };

  useEffect(() => {
    if (announcementQueue.length === 0) {
      setActiveAnnouncement(null);
      return;
    }

    setTimeout(() => {
      setActiveAnnouncement(announcementQueue[0]);
    }, 500);
  }, [announcementQueue]);

  return (
    <div className="reading-quest-reading-container">
      <Streaks streaks={streaks} maxStreaks={maxStreaks} />
      {activeBook && (
        <QuestBook
          key={activeBook.id}
          bk={activeBook}
          bookIndex={bookIndex}
          setBookIndex={setBookIndex}
          bookList={bookList}
          totalReadingTime={totalReadingTime}
          setTotalReadingTime={setTotalReadingTime}
          state={state}
          setState={setState}
          setOuterPageIndex={setPageIndex}
          calculateReadingDuration={calculateReadingDuration}
        />
      )}

      {state === "quiz" && (
        <>
          <QuestQuiz
            bookList={bookList}
            bookIndex={bookIndex}
            setBookIndex={setBookIndex}
            setOuterQuestionIndex={setQuestionIndex}
            readerProfile={readerProfile}
            streaks={streaks}
            maxStreaks={maxStreaks}
            setStreaks={setStreaks}
            setMaxStreaks={setMaxStreaks}
            questions={questions}
            setQuestions={setQuestions}
            calculateReadingDuration={calculateReadingDuration}
            totalReadingTime={totalReadingTime}
            setXp={setXp}
            setAnnouncementQueue={setAnnouncementQueue}
            setState={setState}
          />

          <Rewards xp={xp} />
        </>
      )}
      {activeAnnouncement !== null && (
        <QuestRewardCelebration
          activeAnnouncement={activeAnnouncement}
          announcementQueue={announcementQueue}
          setAnnouncementQueue={setAnnouncementQueue}
          setActiveAnnouncement={setActiveAnnouncement}
        />
      )}
      <QuestProgress
        state={state}
        selectedBooks={bookList}
        bookIndex={bookIndex}
        pageIndex={pageIndex}
        questionIndex={questionIndex}
      />
    </div>
  );
};
